import { render, staticRenderFns } from "./ElementosRegistrales.vue?vue&type=template&id=3b5e27ba&scoped=true&"
import script from "./ElementosRegistrales.vue?vue&type=script&lang=js&"
export * from "./ElementosRegistrales.vue?vue&type=script&lang=js&"
import style0 from "./ElementosRegistrales.vue?vue&type=style&index=0&id=3b5e27ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5e27ba",
  null
  
)

export default component.exports